import _ from "underscore";
import PropTypes from "prop-types";
import React from "react";
import Navigator from "utils/navigator";
import OrgSource from "apps/auth/sources/org-source";

// Sets the token or oid from the URL when they are changed
// Is handled in a component to avoid being called in render
// which causes issues with setState().
class SetGlobalParams extends React.Component {
  static propTypes = {
    params: PropTypes.object,
  };

  componentDidMount() {
    this.handleSetGlobalParams(this.props);
  }

  componentWillReceiveProps(newProps) {
    if (!_.isEqual(newProps.params, this.props.params)) {
      this.handleSetGlobalParams(newProps);
    }
  }

  handleSetGlobalParams = props => {
    const { oid, token } = props.params;
    if (token) {
      Navigator.loginWithMagicToken(oid, token);
    }
    if (oid) {
      OrgSource.setCurrentOrg(oid);
    }
  };

  render() {
    return null;
  }
}

export default SetGlobalParams;
